import { types } from 'mobx-state-tree';

const ThemeStore = types
  .model('Team', {
    isDark: types.optional(types.boolean, false),
    invertingBlockInViewport: types.optional(types.boolean, false),
  })
  .actions(self => ({
    setDark() {
      document.body.classList.add('_dark');
      self.isDark = true;
    },

    setBright() {
      document.body.classList.remove('_dark');
      self.isDark = false;
    },

    setInvertingBlockInViewport(value) {
      self.invertingBlockInViewport = value;
    },

    resetInvertingBlock() {
      self.invertingBlockInViewport = false;
    },
  }));

export default ThemeStore;



// WEBPACK FOOTER //
// ./src/stores/ThemeStore.js